import moment from 'moment';

const profileParameters = {
    SINGLES: 's',
    DOUBLES: 'd',
    DINGLES: 'g',
    LATEST: 'last',
    UPCOMING: 'upcoming',
};

export const getPlayerOverview = async (axiosInstance, playerId) => {
    const url = `v4/player/${playerId}/overview`;
    return axiosInstance.get(url);
};

export const getPlayerResults = async (axiosInstance, resultsParams, playerId) => {
    const { SINGLES, DOUBLES, DINGLES, LATEST } = profileParameters;
    const { gameType, year } = resultsParams;
    const formattedGameType = gameType?.toLowerCase();
    const url = `v4/player/${playerId}/results`;
    const params = {};

    if (formattedGameType === 'doubles') {
        params.type = DOUBLES;
    } else if (formattedGameType === 'dingles') {
        params.type = DINGLES;
    } else {
        params.type = SINGLES;
    }

    params.year = year || LATEST;

    return axiosInstance.get(url, { params });
};

export const getPlayerEvents = async (axiosInstance, eventType, playerId) => {
    const { UPCOMING } = profileParameters;
    const format = 'YYYY-MM-DD';
    const fromDate = eventType === UPCOMING ? moment.utc() : moment.utc().subtract(1, 'y');
    const toDate = eventType === UPCOMING ? moment.utc().add(1, 'y') : moment.utc();
    const formattedFrom = fromDate.format(format);
    const formattedTo = toDate.format(format);
    const url = `v4/player/${playerId}/all-events?FromDate=${formattedFrom}&ToDate=${formattedTo}`;

    return axiosInstance.get(url);
};

export const getPlayerClubs = (axiosInstance, playerId) => {
    const url = `v1/player/${playerId}/clubs`;

    return axiosInstance.get(url);
};

export const getPlayerStats = async (axiosInstance, statsParams, playerId) => {
    const url = `v4/player/${playerId}/all-stats`;
    const params = {
        type: statsParams?.type || 'singles',
        resultType: statsParams?.resultType || 'verified',
        months: statsParams?.months || 6,
        fetchAllResults: statsParams?.fetchAllResults || false,
    };

    return axiosInstance.get(url, { params });
};
